var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { staticClass: "modal-mask" }, [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c("div", { staticClass: "modal-container" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h3", [_vm._v("Select file options...")]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "pull-right",
                attrs: { "aria-label": "close" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_vm._v("X\n          ")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", [
              _vm.current_page === _vm.PAGES.variant
                ? _c(
                    "div",
                    [
                      _c(
                        "b-tabs",
                        {
                          model: {
                            value: _vm.variant_spec_tab,
                            callback: function ($$v) {
                              _vm.variant_spec_tab = $$v
                            },
                            expression: "variant_spec_tab",
                          },
                        },
                        [
                          _c(
                            "b-tab",
                            {
                              staticClass: "pt-3",
                              attrs: { title: "Variant from columns" },
                            },
                            [
                              _c("div", { staticClass: "form-group row" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "col-sm-2",
                                    attrs: { for: "vs-chr-" + _vm._uid },
                                  },
                                  [_vm._v("Chromosome")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-sm-4" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.chrom_col,
                                          expression: "chrom_col",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { id: "vs-chr-" + _vm._uid },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.chrom_col = $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                      },
                                    },
                                    _vm._l(
                                      _vm.column_titles,
                                      function (item, index) {
                                        return _c(
                                          "option",
                                          {
                                            key: index,
                                            domProps: { value: index + 1 },
                                          },
                                          [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(item) +
                                                "\n                        "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "col-sm-2",
                                    attrs: { for: "vs-pos-" + _vm._uid },
                                  },
                                  [_vm._v("Position")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-sm-4" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.pos_col,
                                          expression: "pos_col",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { id: "vs-pos-" + _vm._uid },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.pos_col = $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                      },
                                    },
                                    _vm._l(
                                      _vm.column_titles,
                                      function (item, index) {
                                        return _c(
                                          "option",
                                          {
                                            key: index,
                                            domProps: { value: index + 1 },
                                          },
                                          [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(item) +
                                                "\n                        "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group row" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "col-sm-2",
                                    attrs: { for: "vs-ref-" + _vm._uid },
                                  },
                                  [_vm._v("Ref allele")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-sm-4" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.ref_col,
                                          expression: "ref_col",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { id: "vs-ref-" + _vm._uid },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.ref_col = $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                      },
                                    },
                                    _vm._l(
                                      _vm.column_titles,
                                      function (item, index) {
                                        return _c(
                                          "option",
                                          {
                                            key: index,
                                            domProps: { value: index + 1 },
                                          },
                                          [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(item) +
                                                "\n                        "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "col-sm-2",
                                    attrs: { for: "vs-alt-" + _vm._uid },
                                  },
                                  [_vm._v("Alt allele")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-sm-4" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.alt_col,
                                          expression: "alt_col",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { id: "vs-alt-" + _vm._uid },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.alt_col = $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                      },
                                    },
                                    _vm._l(
                                      _vm.column_titles,
                                      function (item, index) {
                                        return _c(
                                          "option",
                                          {
                                            key: index,
                                            domProps: { value: index + 1 },
                                          },
                                          [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(item) +
                                                "\n                        "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tab",
                            {
                              staticClass: "pt-3",
                              attrs: { title: "Variant from marker" },
                            },
                            [
                              _c("div", { staticClass: "form-group row" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "col-sm-2",
                                    attrs: { for: "vs-marker-" + _vm._uid },
                                  },
                                  [_vm._v("Marker")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-sm-4" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.marker_col,
                                          expression: "marker_col",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { id: "vs-marker-" + _vm._uid },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.marker_col = $event.target
                                            .multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                      },
                                    },
                                    _vm._l(
                                      _vm.column_titles,
                                      function (item, index) {
                                        return _c(
                                          "option",
                                          {
                                            key: index,
                                            domProps: { value: index + 1 },
                                          },
                                          [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(item) +
                                                "\n                        "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-2",
                            attrs: { for: "vs-pval-" + _vm._uid },
                          },
                          [_vm._v("P-value column")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-4" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.pvalue_col,
                                  expression: "pvalue_col",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { id: "vs-pval-" + _vm._uid },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.pvalue_col = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            _vm._l(_vm.column_titles, function (item, index) {
                              return _c(
                                "option",
                                { key: index, domProps: { value: index + 1 } },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(item) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-2" }, [
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label",
                              staticStyle: { "white-space": "nowrap" },
                              attrs: { for: "is_neg_log_pvalue" },
                            },
                            [
                              _vm._v("\n                    is "),
                              _c("em", [
                                _vm._v("-log"),
                                _c("sub", [_vm._v("10")]),
                                _vm._v("(p)"),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-4" }, [
                          _c("div", { staticClass: "form-check float-left" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.is_neg_log_pvalue,
                                  expression: "is_neg_log_pvalue",
                                },
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                id: "is_neg_log_pvalue",
                                type: "checkbox",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.is_neg_log_pvalue)
                                  ? _vm._i(_vm.is_neg_log_pvalue, null) > -1
                                  : _vm.is_neg_log_pvalue,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.is_neg_log_pvalue,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.is_neg_log_pvalue = $$a.concat([
                                          $$v,
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.is_neg_log_pvalue = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.is_neg_log_pvalue = $$c
                                  }
                                },
                              },
                            }),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm.current_page === _vm.PAGES.optional
                ? _c("div", [
                    _c("h3", [_vm._v("Optional fields")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group row" }, [
                      _c(
                        "label",
                        {
                          staticClass: "col-sm-2",
                          attrs: { for: "vs-beta-" + _vm._uid },
                        },
                        [_vm._v("Effect size")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-4" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.beta_col,
                                expression: "beta_col",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { id: "vs-beta-" + _vm._uid },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.beta_col = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          _vm._l(_vm.column_titles, function (item, index) {
                            return _c(
                              "option",
                              { key: index, domProps: { value: index + 1 } },
                              [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(item) +
                                    "\n                    "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-6" }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group row" }, [
                      _c(
                        "label",
                        {
                          staticClass: "col-sm-2",
                          attrs: { for: "vs-stderr-" + _vm._uid },
                        },
                        [_vm._v("Std. Err.")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-4" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.stderr_beta_col,
                                expression: "stderr_beta_col",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { id: "vs-stderr-" + _vm._uid },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.stderr_beta_col = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          _vm._l(_vm.column_titles, function (item, index) {
                            return _c(
                              "option",
                              { key: index, domProps: { value: index + 1 } },
                              [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(item) +
                                    "\n                    "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("h4", [_vm._v("Allele Frequency")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group row" }, [
                      _c("label", { staticClass: "col-sm-2" }, [
                        _vm._v("Effect allele"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-10" },
                        [
                          _c(
                            "b-form-radio",
                            {
                              attrs: { value: false, inline: "" },
                              model: {
                                value: _vm.is_alt_effect,
                                callback: function ($$v) {
                                  _vm.is_alt_effect = $$v
                                },
                                expression: "is_alt_effect",
                              },
                            },
                            [_vm._v("Ref")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-radio",
                            {
                              attrs: { value: true, inline: "" },
                              model: {
                                value: _vm.is_alt_effect,
                                callback: function ($$v) {
                                  _vm.is_alt_effect = $$v
                                },
                                expression: "is_alt_effect",
                              },
                            },
                            [_vm._v("Alt")]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group row" }, [
                      _c("label", { staticClass: "col-sm-2" }, [
                        _vm._v("Specify from"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-10" },
                        [
                          _c(
                            "b-form-radio",
                            {
                              attrs: { value: _vm.AF_SPEC.freq, inline: "" },
                              model: {
                                value: _vm.freq_spec_option,
                                callback: function ($$v) {
                                  _vm.freq_spec_option = $$v
                                },
                                expression: "freq_spec_option",
                              },
                            },
                            [_vm._v("Frequency")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-radio",
                            {
                              attrs: { value: _vm.AF_SPEC.count, inline: "" },
                              model: {
                                value: _vm.freq_spec_option,
                                callback: function ($$v) {
                                  _vm.freq_spec_option = $$v
                                },
                                expression: "freq_spec_option",
                              },
                            },
                            [_vm._v("Counts")]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.freq_spec_option === _vm.AF_SPEC.freq
                      ? _c("div", [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "label",
                              {
                                staticClass: "col-sm-2",
                                attrs: { for: "vs-af-freq-" + _vm._uid },
                              },
                              [_vm._v("Frequency")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-sm-4" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.allele_freq_col,
                                      expression: "allele_freq_col",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { id: "vs-af-freq-" + _vm._uid },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.allele_freq_col = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                _vm._l(
                                  _vm.column_titles,
                                  function (item, index) {
                                    return _c(
                                      "option",
                                      {
                                        key: index,
                                        domProps: { value: index + 1 },
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(item) +
                                            "\n                      "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-sm-6" }),
                          ]),
                        ])
                      : _vm.freq_spec_option === _vm.AF_SPEC.count
                      ? _c("div", [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "label",
                              {
                                staticClass: "col-sm-2",
                                attrs: { for: "vs-af-count-" + _vm._uid },
                              },
                              [_vm._v("Count")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-sm-4" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.allele_count_col,
                                      expression: "allele_count_col",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { id: "vs-af-count-" + _vm._uid },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.allele_count_col = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                _vm._l(
                                  _vm.column_titles,
                                  function (item, index) {
                                    return _c(
                                      "option",
                                      {
                                        key: index,
                                        domProps: { value: index + 1 },
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(item) +
                                            "\n                      "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "col-sm-2",
                                attrs: { for: "vs-af-ns-" + _vm._uid },
                              },
                              [_vm._v("# Samples")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-sm-4" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.n_samples_col,
                                      expression: "n_samples_col",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { id: "vs-af-ns-" + _vm._uid },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.n_samples_col = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                _vm._l(
                                  _vm.column_titles,
                                  function (item, index) {
                                    return _c(
                                      "option",
                                      {
                                        key: index,
                                        domProps: { value: index + 1 },
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(item) +
                                            "\n                      "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]),
                        ])
                      : _c("div", [
                          _c("span", { staticClass: "text-muted" }, [
                            _vm._v(
                              "\n                  Please select a frequency option in order to use this feature\n                "
                            ),
                          ]),
                        ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "card card-body bg-light" }, [
                  _vm.isValid && _vm.preview.error
                    ? _c("div", [
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.preview.error)),
                        ]),
                      ])
                    : _vm.isValid
                    ? _c("div", [
                        _c("table", { staticClass: "preview-table" }, [
                          _c("tr", [
                            _c("td", [_vm._v("Variant")]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(_vm.preview.variant))]),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [
                              _vm._v("-log"),
                              _c("sub", [_vm._v("10")]),
                              _vm._v("(p)"),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(_vm.preview.log_pvalue.toFixed(3))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [_vm._v("β")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.preview.beta
                                    ? _vm.preview.beta.toFixed(3)
                                    : ""
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [_vm._v("SE(β)")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.preview.stderr_beta
                                    ? _vm.preview.stderr_beta.toFixed(3)
                                    : ""
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [_vm._v("Allele freq")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.preview.alt_allele_freq
                                      ? _vm.preview.alt_allele_freq.toFixed(3)
                                      : ""
                                  ) +
                                  "\n                      "
                              ),
                            ]),
                          ]),
                        ]),
                      ])
                    : _c("div", [
                        _vm._v(
                          "\n                  Please select options to preview parsed data.\n                "
                        ),
                      ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row mt-3" }, [
                _vm.current_page === _vm.PAGES.optional
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-success ml-auto",
                        attrs: { disabled: !_vm.isValid },
                        on: { click: _vm.sendOptions },
                      },
                      [
                        _vm._v(
                          "\n                Accept options\n              "
                        ),
                      ]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "btn btn-success ml-auto",
                        attrs: { disabled: !_vm.isValid },
                        on: {
                          click: function ($event) {
                            _vm.current_page += 1
                          },
                        },
                      },
                      [_vm._v("Next\n              ")]
                    ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }